<template>
	<div class="detail-view">
		<VideoPage></VideoPage>
	</div>
</template>

<script>
import VideoPage from "../components/pages/VideoPage";
import { inject } from "vue";

export default {
  name: "Video",
  components: {VideoPage},
  setup() {
    const store = inject("store");
    return {
			actions: store.actions
    };
  },

}
</script>

<style scoped>

</style>
